<app-uzemszunet-sav forras="aggreg8"></app-uzemszunet-sav>

<!-- BANKSZÁMLÁK -->
<div class="naplo-fejlec" *ngIf="nezet === 'szamlak'">
  <h2>Bankszámlák</h2>
  <span class="n-alcim">Bank</span>
  <div class="spacer"></div>
  <ion-button size="small" fill="outline" style="--color:#fff;--border-color:rgba(255,255,255,.6)" [disabled]="ellenorzFut" (click)="mandateEllenoriz(false)">
    <ion-spinner *ngIf="ellenorzFut" name="dots"></ion-spinner>
    <span *ngIf="!ellenorzFut"><ion-icon slot="start" name="refresh-outline"></ion-icon>Kapcsolat ellenőrzése</span>
  </ion-button>
  <ion-button size="small" (click)="bankOsszekot()">
    <ion-icon slot="start" name="link-outline"></ion-icon>Bank összekötése
  </ion-button>
</div>

<!-- BANK KONTÍROZÁS -->
<div class="naplo-fejlec" *ngIf="nezet === 'kontir'">
  <h2>Bank kontírozás</h2>
  <span class="n-alcim">Javaslat · párosítás · könyvelés · RLB-feladás</span>
  <div class="spacer"></div>
  <ion-button size="small" fill="outline" style="--color:#fff;--border-color:rgba(255,255,255,.6)" (click)="konyvel()" [disabled]="konyvelFut" title="A kontírozott/párosított tételek könyvelése (vegyes bizonylat)">
    <ion-spinner *ngIf="konyvelFut" name="dots"></ion-spinner>
    <span *ngIf="!konyvelFut"><ion-icon slot="start" name="book-outline"></ion-icon>Könyvelés</span>
  </ion-button>
  <ion-button size="small" fill="outline" style="--color:#fff;--border-color:rgba(255,255,255,.6)" (click)="rlbNyit()" [disabled]="rlbFut" title="A kontírozott/könyvelt banki tételek letöltése RLB többsoros formátumba (megadható időszakra)">
    <ion-spinner *ngIf="rlbFut" name="dots"></ion-spinner>
    <span *ngIf="!rlbFut"><ion-icon slot="start" name="download-outline"></ion-icon>RLB-feladás</span>
  </ion-button>
  <ion-button size="small" fill="clear" style="--color:#fff" (click)="szabalyokNyit()" title="Kontír-szabályok"><ion-icon slot="icon-only" name="options-outline"></ion-icon></ion-button>
  <ion-button size="small" fill="clear" style="--color:#fff" (click)="aliasNyit()" title="RLB partner-nevek (banki név → RLB-név az exporthoz)"><ion-icon slot="icon-only" name="people-outline"></ion-icon></ion-button>
</div>

<div class="ures" *ngIf="!aktiv.ugyfelId"><ion-icon name="business"></ion-icon>Válassz ügyfelet.</div>

<ng-container *ngIf="aktiv.ugyfelId">
  <ng-container *ngIf="nezet === 'szamlak'">
  <!-- Bankszámlák -->
  <div class="naplo-eszkozsor">
    <h3 style="margin:0;color:var(--naplo)">Bankszámlák</h3>
    <div class="spacer" style="flex:1"></div>
    <span style="font-size:.8rem;color:#64748b">Szinkron:</span>
    <input type="date" [(ngModel)]="szinkronTartomany.tol" title="Tól" style="font-size:.8rem;padding:3px 6px;border:1px solid #cbd5e1;border-radius:6px">
    <span style="color:#94a3b8">–</span>
    <input type="date" [(ngModel)]="szinkronTartomany.ig" title="Ig" style="font-size:.8rem;padding:3px 6px;border:1px solid #cbd5e1;border-radius:6px">
    <ion-button size="small" fill="outline" (click)="szinkron()" [disabled]="szinkronFut">
      <ion-spinner *ngIf="szinkronFut === 'mind'" name="dots"></ion-spinner>
      <span *ngIf="szinkronFut !== 'mind'"><ion-icon slot="start" name="sync-outline"></ion-icon>Mind szinkron</span>
    </ion-button>
    <ion-button size="small" fill="outline" color="medium" (click)="ujSzamlaNyit()"><ion-icon slot="start" name="add"></ion-icon>Kézi felvétel</ion-button>
    <!--  Kipontozó ablak: a nyitott vevő/szállító számlák és a még ki nem pontozott banktételek
          egy képernyőn – 1:1 és csoportos kiegyenlítés is (egy tétel több számlára, egy számla
          több tételből). -->
    <ion-button size="small" style="--background:var(--naplo)" (click)="vszNyit()">
      <ion-icon slot="start" name="git-compare-outline"></ion-icon>V/SZ kiegyenlítés
    </ion-button>
  </div>

  <div *ngIf="!szamlak.length" class="ures"><ion-icon name="card-outline"></ion-icon>Nincs összekötött bankszámla. Kösd össze a bankot (Aggreg8 meghatalmazás).</div>

  <div class="tabla-wrap" *ngIf="szamlak.length">
    <table class="naplo-tabla">
      <thead><tr><th>IBAN</th><th>Bank</th><th *ngIf="!egyszeres">Főkönyvi</th><th>Meghatalmazás</th><th>Adat eddig</th><th>Utolsó szinkron</th><th class="jobb">Műveletek</th></tr></thead>
      <tbody>
        <tr *ngFor="let b of szamlak">
          <td><b>{{ b.iban }}</b></td>
          <td>{{ b.bank_nev || '—' }} <ion-badge *ngIf="b.banktipus && b.banktipus!=='bank'" color="medium">{{ b.banktipus }}</ion-badge></td>
          <td *ngIf="!egyszeres">{{ b.fokonyvi_szam || '—' }}</td>
          <td>
            <ion-badge *ngIf="b.aktiv && !lejarKozel(b)" color="success">aktív</ion-badge>
            <ion-badge *ngIf="b.aktiv && lejarKozel(b)" color="warning">hamarosan lejár</ion-badge>
            <ion-badge *ngIf="!b.aktiv" color="danger">lejárt / függő</ion-badge>
            <span class="halvany" *ngIf="b.mandate_lejarat" style="font-size:.78rem"> {{ b.mandate_lejarat | date:'yyyy.MM.dd' }}</span>
          </td>
          <!-- Meddig van EGYÁLTALÁN adat az adatszolgáltatónál. Ha ez napokkal elmarad, a banki
               hozzájárulás fogyott el – a szinkron ilyenkor is „sikeres", csak nem hoz semmit. -->
          <td [class.halvany]="!adatElakadt(b)">
            {{ b.utolso_tetel_datum ? (b.utolso_tetel_datum | date:'yyyy.MM.dd') : '—' }}
            <ion-badge *ngIf="adatElakadt(b)" color="danger" [title]="'Az adatfolyam elakadt – valószínűleg lejárt a banki hozzájárulás. Add meg újra a meghatalmazást.'">
              {{ adatElmaradas(b) }} napja áll
            </ion-badge>
          </td>
          <td class="halvany">{{ b.utolso_szinkron ? (b.utolso_szinkron | date:'yyyy.MM.dd HH:mm') : '—' }}</td>
          <td class="jobb muveletek">
            <ion-button size="small" fill="clear" color="primary" title="Szinkron" [disabled]="szinkronFut || !b.aktiv" (click)="szinkron(b)">
              <ion-spinner *ngIf="szinkronFut === b.id" name="dots"></ion-spinner>
              <ion-icon *ngIf="szinkronFut !== b.id" slot="icon-only" name="sync-outline"></ion-icon>
            </ion-button>
            <ion-button size="small" fill="clear" color="tertiary" title="Megújító email az ügyfélnek" (click)="emailUgyfelnek(b)"><ion-icon slot="icon-only" name="mail-outline"></ion-icon></ion-button>
            <ion-button size="small" fill="clear" title="Szerkesztés" (click)="ujSzamlaNyit(b)"><ion-icon slot="icon-only" name="create-outline"></ion-icon></ion-button>
            <ion-button size="small" fill="clear" color="danger" title="Törlés" (click)="szamlaTorol(b)"><ion-icon slot="icon-only" name="trash-outline"></ion-icon></ion-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Kézi számla-felvétel modal -->
  <div class="kezi-szamla" *ngIf="ujSzamla">
    <ion-card class="naplo-card">
      <ion-card-content>
        <ion-grid><ion-row>
          <ion-col size="12" sizeMd="4"><ion-item><ion-input label="IBAN / számlaszám" labelPlacement="stacked" [(ngModel)]="ujSzamla.iban"></ion-input></ion-item></ion-col>
          <ion-col size="12" sizeMd="4"><ion-item><ion-input label="Bank neve" labelPlacement="stacked" [(ngModel)]="ujSzamla.bank_nev"></ion-input></ion-item></ion-col>
          <ion-col size="6" sizeMd="2" *ngIf="!egyszeres"><ion-item><ion-input label="Főkönyvi szám" labelPlacement="stacked" [(ngModel)]="ujSzamla.fokonyvi_szam"></ion-input></ion-item></ion-col>
          <ion-col size="6" sizeMd="2"><ion-item><ion-select label="Típus" labelPlacement="stacked" [(ngModel)]="ujSzamla.banktipus">
            <ion-select-option value="bank">bank</ion-select-option><ion-select-option value="stripe">stripe</ion-select-option>
            <ion-select-option value="futar">futár</ion-select-option><ion-select-option value="kartya">kártya</ion-select-option>
          </ion-select></ion-item></ion-col>
        </ion-row></ion-grid>
        <ion-button size="small" style="--background:var(--naplo)" (click)="szamlaMent()"><ion-icon slot="start" name="save"></ion-icon>Mentés</ion-button>
        <ion-button size="small" fill="clear" color="medium" (click)="ujSzamla = null">Mégse</ion-button>
      </ion-card-content>
    </ion-card>
  </div>

  </ng-container>

  <!-- BANK KONTÍROZÁS – két fül. Az alapfül maga a kontír-JAVASLAT, közvetlenül az oldalon (korábban
       egy gombbal nyitott ablakban volt); semmi nem mentődik, amíg a „Mehet"-et meg nem nyomod.
       A Számlatörténet fülön a banki tételek teljes listája (szűrés, kézi kontír, visszavonás). -->
  <ng-container *ngIf="nezet === 'kontir'">
  <div class="n-fulek">
    <button type="button" [class.aktiv]="ful === 'javaslat'" (click)="fulValt('javaslat')">Kontír-javaslat</button>
    <button type="button" [class.aktiv]="ful === 'tortenet'" (click)="fulValt('tortenet')">Számlatörténet</button>
  </div>

  <!-- ═══ KONTÍR-JAVASLAT ═══ -->
  <ng-container *ngIf="ful === 'javaslat'">
    <!-- A Mind/kijelölés/Mehet a dátumszűrővel LÁTHATÓ sorokra hat (rejtett sor nem mentődik). -->
    <div class="n-szuro-sor">
      <label title="Csak a megadott dátumtartomány tételei látszanak">Dátumtól <input type="date" [(ngModel)]="javaszTol"></label>
      <label title="Csak a megadott dátumtartomány tételei látszanak">Dátumig <input type="date" [(ngModel)]="javaszIg"></label>
      <ion-button size="small" fill="clear" color="medium" *ngIf="javaszTol || javaszIg" (click)="javaslatSzuroTorol()" title="Dátumszűrő törlése">
        <ion-icon slot="icon-only" name="close-circle-outline"></ion-icon>
      </ion-button>
      <!-- A korábbi „Mindenre" gomb kapcsolóként: a már kontírozott tételekre is kér javaslatot. -->
      <label title="A már kontírozottakra is kér javaslatot">
        <ion-toggle [ngModel]="javaslatUjra" (ngModelChange)="javaslatUjra = $event; kontirJavaslat()" [disabled]="kontirFut"></ion-toggle> Kontírozottakra is
      </label>
      <!-- RLB segéd mód: más számlákat kínál fel a párosításhoz, ezért a váltás újrakéri a javaslatot. -->
      <label title="Bekapcsolva MINDEN számla felajánlható kontírozásra, nem csak a már lekönyveltek">
        <ion-toggle [ngModel]="rlbSeged" (ngModelChange)="javaslatRlbSegedValt($event)" [disabled]="kontirFut"></ion-toggle> RLB segéd mód
      </label>
      <div class="spacer"></div>
      <ion-spinner *ngIf="kontirFut" name="dots"></ion-spinner>
      <span class="halvany" style="font-size:12px">{{ javaslatKivalasztva() }} / {{ javaslatokSzurve.length }} kijelölve</span>
      <ion-button size="small" fill="clear" (click)="javaslatMindKivalaszt(true)">Mind</ion-button>
      <ion-button size="small" fill="clear" color="medium" (click)="javaslatMindKivalaszt(false)">Egyik se</ion-button>
      <ion-button size="small" style="--background:var(--naplo)" (click)="javaslatMehet()" [disabled]="veglegesitFut || kontirFut || !javaslatKivalasztva()">
        <ion-spinner *ngIf="veglegesitFut" name="dots"></ion-spinner>
        <span *ngIf="!veglegesitFut"><ion-icon slot="start" name="checkmark-done-outline"></ion-icon>Mehet ({{ javaslatKivalasztva() }})</span>
      </ion-button>
    </div>

    <div *ngIf="kontirFut && !javaslatok.length" class="ures">Kontír-javaslat készül…</div>
    <div *ngIf="!kontirFut && !javaslatok.length" class="ures"><ion-icon name="sparkles-outline"></ion-icon>{{ javaslatUjra ? 'Nincs kontírozható tétel.' : 'Nincs új tétel a kontírozáshoz.' }}</div>
    <div *ngIf="javaslatok.length && !javaslatokSzurve.length" class="ures"><ion-icon name="calendar-outline"></ion-icon>A megadott dátumtartományban nincs javaslat.</div>

    <ng-container *ngIf="javaslatokSzurve.length">
      <datalist id="partnerNevekLista"><option *ngFor="let n of partnerNevek" [value]="n"></option></datalist>
      <div class="tabla-wrap">
        <table class="naplo-tabla">
          <thead><tr>
            <th style="width:34px"></th><th>Dátum</th><th>Partner</th><th>Közlemény</th><th class="num">Összeg</th>
            <th>Forrás</th><th>Típus</th><th>{{ egyszeres ? 'Rovat' : 'Ellenszámla' }}</th><th>{{ egyszeres ? 'Napló' : 'T / K' }}</th><th>Számla párosítás</th><th title="Tanuld meg a partnerre">Tanul</th>
          </tr></thead>
          <tbody>
            <tr *ngFor="let j of javaslatokSzurve" [style.opacity]="j.kivalaszt ? 1 : .45">
              <td><input type="checkbox" [(ngModel)]="j.kivalaszt"></td>
              <td style="white-space:nowrap">{{ j.datum | date:'yyyy.MM.dd' }}</td>
              <td class="n-partner-cella" style="min-width:170px" [title]="j.partner_nev || ''">
                <div class="n-partner-nev">{{ j.partner_nev || '—' }}</div>
                <div class="halvany" *ngIf="j.partner_szamla" style="font-size:.74rem">{{ j.partner_szamla }}</div>
                <!-- A partner felülírható: ez megy a bizonylatra és az RLB-exportba (a banki név marad). -->
                <input [(ngModel)]="j.partner_felulir" class="j-mezo partner-felulir" list="partnerNevekLista"
                       placeholder="partner felülírása…" autocomplete="off" title="Más partnerre könyvelés – üresen hagyva a banki / számla szerinti partner marad">
              </td>
              <td class="halvany" style="max-width:200px;white-space:normal">{{ j.kozlemeny }}</td>
              <td class="num" [style.color]="(j.osszeg||0)<0 ? '#b91c1c' : '#15803d'"><b>{{ fmt(j.osszeg) }}</b>
                <div *ngIf="!j.devizaSzerk && j.deviza_nem" class="halvany" style="font-size:.72rem">{{ j.deviza_osszeg }} {{ j.deviza_nem }}</div>
                <!-- Kézi devizásítás: a várt deviza összegből a rendszer számolja az árfolyamot. -->
                <div *ngIf="j.devizaSzerk" class="deviza-kezi">
                  <input type="number" step="0.01" min="0" [(ngModel)]="j.deviza_osszeg" (change)="javaslatDevizaValt(j)" placeholder="deviza" class="j-mezo">
                  <select [(ngModel)]="j.deviza_nem" (change)="javaslatDevizaValt(j)" class="j-mezo">
                    <option *ngFor="let d of DEVIZANEMEK" [value]="d">{{ d }}</option>
                  </select>
                  <div class="halvany" *ngIf="devizaArfolyam(j) as arf">árf. {{ arf }}</div>
                </div>
                <button type="button" class="deviza-kapcs" (click)="devizaKapcs(j)"
                        [title]="j.devizaSzerk ? 'Kézi deviza elrejtése' : 'Devizásítás: add meg a várt deviza összeget'">{{ j.devizaSzerk ? '− deviza' : '+ deviza' }}</button>
              </td>
              <td><ion-badge [color]="j.forras==='szabaly' ? 'primary' : (j.forras==='tanult' ? 'tertiary' : (j.forras==='atvezetes' ? 'success' : 'medium'))" style="font-size:.7rem">{{ javaslatForrasCimke(j.forras) }}</ion-badge></td>
              <td><select [(ngModel)]="j.tipus" class="j-mezo">
                <option *ngFor="let x of TIPUSOK" [value]="x.k">{{ x.c }}</option>
              </select></td>
              <td style="width:1%"><div class="fk-mezo">
                <input [(ngModel)]="j.fokonyvi_szam" class="j-mezo j-szam" [placeholder]="egyszeres ? 'pl. 3' : 'pl. 4541'">
                <button type="button" class="fk-mini" (click)="fkNyit(j, 'fokonyvi_szam')" [title]="egyszeres ? 'Választás a rovatok közül' : 'Választás a számlatükörből'"><ion-icon name="list-outline"></ion-icon></button>
              </div><div class="halvany" *ngIf="j.fokonyvi_szam && fkNev(j.fokonyvi_szam)" style="font-size:.7rem;max-width:150px;white-space:normal">{{ fkNev(j.fokonyvi_szam) }}</div></td>
              <td style="white-space:nowrap"><span class="tk-cella" *ngIf="j.fokonyvi_szam">
                <ng-container *ngIf="!egyszeres"><b>{{ tk(j).t }}</b> / <b>{{ tk(j).k }}</b></ng-container>
                <ng-container *ngIf="egyszeres">{{ naploIrany(j) }} · <b>{{ j.fokonyvi_szam }}</b></ng-container></span>
                <span class="halvany" *ngIf="egyszeres && !j.fokonyvi_szam && j.tipus === 'atvezetes'">nem könyvelendő</span></td>
              <td style="min-width:280px">
                <ng-container *ngIf="parosithato(j.tipus); else nincsParos">
                  <div style="display:flex;gap:4px;align-items:center">
                    <select [ngModel]="egyszeruSzamlaId(j)" (ngModelChange)="egyszeruValaszt(j, $event)" class="j-mezo" [class.j-parositva]="j.parositasok?.length" style="max-width:210px">
                      <option [ngValue]="null">— nincs párosítás —</option>
                      <option *ngFor="let s of j.szamlak" [ngValue]="s.id">{{ szamlaCimke(s) }}</option>
                      <option *ngIf="j.parositasok?.length > 1" [ngValue]="'TOBB'">bontott ({{ j.parositasok.length }} db)</option>
                    </select>
                    <ion-button size="small" fill="clear" (click)="bontasNyit(j)" title="Bontás több számlára"><ion-icon slot="icon-only" name="git-branch-outline"></ion-icon></ion-button>
                  </div>
                  <div *ngIf="j.megjegyzes" style="font-size:.72rem;color:#b45309;white-space:normal;max-width:320px">{{ j.megjegyzes }}</div>
                  <!-- Devizás párosításnál a keret is devizában értendő (a banktétel deviza-összege),
                       mellette a könyv szerinti forintérték – így soha nem keveredik a kettő. -->
                  <!-- A párosított oldalt MINDIG a kerettel azonos pénznemben mérjük:
                       azonos devizánál devizában, forintos banktételnél forintban. -->
                  <div *ngIf="j.parositasok?.length" class="halvany" style="font-size:.72rem">párosítva:
                    <!-- devizás párosításnál a többlet nem hiba, hanem árfolyam-eltérés -->
                    <b [style.color]="parosMertOsszeg(j) > parosKeret(j)+0.5 ? (parosDevizas(j) ? '#b45309' : '#b91c1c') : '#15803d'">{{ fmt(parosMertOsszeg(j)) }}</b> / {{ fmt(parosKeret(j)) }} {{ parosPenznem(j) }}
                    <span *ngIf="parosDevizas(j) && !parosAzonosDeviza(j)"> ({{ fmt(parositasOsszeg(j)) }} {{ parositasok0Deviza(j) }})</span>
                  </div>
                  <div *ngIf="j.arfolyam && j.arfolyam.kulonbozet" style="font-size:.72rem;margin-top:2px">
                    <ion-badge [color]="j.arfolyam.kulonbozet > 0 ? 'success' : 'danger'"
                               [title]="'A véglegesítéskor automatikusan bekerül a vegyes bizonylatba: ' + (j.arfolyam.kulonbozet > 0 ? 'nyereség 9762 (K)' : 'veszteség 8762 (T)')">
                      árf. {{ j.arfolyam.kulonbozet > 0 ? 'nyereség' : 'veszteség' }} {{ fmt(j.arfolyam.kulonbozet) }} Ft → {{ j.arfolyam.szamla }}
                    </ion-badge>
                  </div>
                </ng-container>
                <ng-template #nincsParos><span class="halvany" style="font-size:.78rem">—</span></ng-template>
              </td>
              <td style="text-align:center"><input type="checkbox" [(ngModel)]="j.tanul"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </ng-container>

  <!-- ═══ SZÁMLATÖRTÉNET ═══ -->
  <ng-container *ngIf="ful === 'tortenet'">
    <!-- Tranzakciók (Bank kontírozás): tömör szűrősor. A dátum-tartomány a listát szűri, ÉS ez a
         hatóköre a tömeges kontír-visszavonásnak. -->
    <div class="n-szuro-sor">
      <label>Számla
        <select [(ngModel)]="szuro.bank_id" (ngModelChange)="tranzakcioBetolt()">
          <option value="">Minden számla</option>
          <option *ngFor="let b of szamlak" [value]="b.id">{{ b.bank_nev || 'Bank' }} – …{{ (b.iban || '').slice(-8) }}</option>
        </select>
      </label>
      <label>Státusz
        <select [(ngModel)]="szuro.statusz" (ngModelChange)="tranzakcioBetolt()">
          <option value="">Mind</option><option value="uj">Új</option><option value="kontirozott">Kontírozott</option>
          <option value="parositott">Párosított</option><option value="konyvelt">Könyvelt</option><option value="fuggo">Függő</option>
        </select>
      </label>
      <label>Dátumtól <input type="date" [(ngModel)]="szuro.tol" (ngModelChange)="tranzakcioBetolt()"></label>
      <label>Dátumig <input type="date" [(ngModel)]="szuro.ig" (ngModelChange)="tranzakcioBetolt()"></label>
      <div class="spacer"></div>
      <!-- RLB segéd mód: egyszeres könyvelésnél a számla nem kettős tételként jelenik meg,
           ezért az alapértelmezett „csak lekönyvelt számla" szűrő mindent kizárna. -->
      <label title="Bekapcsolva MINDEN számla felajánlható kontírozásra, nem csak a már lekönyveltek">
        <ion-toggle [ngModel]="rlbSeged" (ngModelChange)="rlbSegedValt($event)"></ion-toggle> RLB segéd mód
      </label>
      <!-- Árfolyam-különbözet: mi küldjük önálló vegyes bizonylatként, vagy az RLB számolja. -->
      <label title="Bekapcsolva MI küldjük az árfolyam-különbözetet (XF/XT, 9762/8762). Kikapcsolva a banki sor hivatkozásos formában megy, és az RLB számolja a különbözetet.">
        <ion-toggle [ngModel]="rlbArfolyam" (ngModelChange)="rlbArfolyamValt($event)"></ion-toggle> Árfolyam-bizonylat
      </label>
      <ion-button size="small" fill="outline" color="danger" [disabled]="tomegesVisszavonFut" (click)="kontirVisszavonTomeges()"
                  title="A SZŰRT lista összes kontírjának visszavonása (a párosításokkal együtt)">
        <ion-spinner *ngIf="tomegesVisszavonFut" name="dots"></ion-spinner>
        <span *ngIf="!tomegesVisszavonFut"><ion-icon slot="start" name="arrow-undo-outline"></ion-icon>Kontír visszavonása (szűrt)</span>
      </ion-button>
    </div>

    <div *ngIf="!tranzakciok.length" class="ures"><ion-icon name="swap-horizontal-outline"></ion-icon>Nincs banki tétel. Indíts szinkront a Bank → Bankszámlák oldalon.</div>

    <div class="tabla-wrap" *ngIf="tranzakciok.length">
      <table class="naplo-tabla">
        <thead><tr><th>Dátum</th><th>Számla</th><th>Partner</th><th>Közlemény</th><th class="num">Összeg</th><th>{{ egyszeres ? 'Kontír (rovat)' : 'Kontír (T / K)' }}</th><th>Típus</th><th>Státusz</th><th class="jobb"></th></tr></thead>
        <tbody>
          <tr *ngFor="let t of tranzakciok">
            <td style="white-space:nowrap">{{ t.datum | date:'yyyy.MM.dd' }}</td>
            <td class="halvany" [title]="t.iban">…{{ (t.iban || '').slice(-8) }}</td>
            <td class="n-partner-cella" [title]="t.partner_felulir || t.partner_nev || ''">
              <ng-container *ngIf="t.partner_felulir; else bankiPartner">
                <div class="n-partner-nev"><b>{{ t.partner_felulir }}</b></div>
                <div class="halvany" style="font-size:.74rem" title="A banki partnernév">bank: {{ t.partner_nev || '—' }}</div>
              </ng-container>
              <ng-template #bankiPartner><div class="n-partner-nev">{{ t.partner_nev || '—' }}</div></ng-template>
              <div class="halvany" *ngIf="t.partner_szamla" style="font-size:.76rem">{{ t.partner_szamla }}</div></td>
            <td class="halvany"><div class="n-ket-sor" [title]="t.kozlemeny">{{ t.kozlemeny }}</div></td>
            <td class="num" [style.color]="(t.osszeg||0) < 0 ? '#b91c1c' : '#15803d'"><b>{{ fmt(t.osszeg) }}</b> {{ t.devizanem }}
              <div *ngIf="t.deviza_nem && t.deviza_nem !== 'HUF' && t.deviza_osszeg" class="halvany" style="font-size:.72rem"
                   [title]="t.deviza_kezi == 1 ? 'Kézzel megadott deviza' : 'A közleményből olvasott deviza'">{{ t.deviza_osszeg }} {{ t.deviza_nem }} · {{ devizaArfolyam(t) }}{{ t.deviza_kezi == 1 ? ' (kézi)' : '' }}</div></td>
            <td style="white-space:nowrap">
              <span *ngIf="t.fokonyvi_szam && !egyszeres" class="tk-cella"><b>{{ tk(t).t }}</b> / <b>{{ tk(t).k }}</b></span>
              <span *ngIf="t.fokonyvi_szam && egyszeres" class="tk-cella" [title]="fkNev(t.fokonyvi_szam)">{{ naploIrany(t) }} · <b>{{ t.fokonyvi_szam }}</b></span>
              <span *ngIf="!t.fokonyvi_szam" class="halvany">—</span>
            </td>
            <td><ion-badge color="medium" *ngIf="t.tipus">{{ tipusCimke(t.tipus) }}</ion-badge></td>
            <td><ion-badge [color]="t.statusz==='konyvelt' ? 'success' : (t.statusz==='parositott' ? 'tertiary' : (t.statusz==='kontirozott' ? 'primary' : (t.statusz==='fuggo' ? 'warning' : 'medium')))">{{ t.statusz }}</ion-badge></td>
            <td class="jobb" style="white-space:nowrap">
              <ion-button size="small" fill="clear" title="Kontír szerkesztése" (click)="trSzerkeszt(t)"><ion-icon slot="icon-only" name="create-outline"></ion-icon></ion-button>
              <!-- Kontír visszavonása: a párosítással jóváírt összegeket is visszagörgeti a
                   számlákra, így a tétel újra kontírozható/párosítható. -->
              <ion-button size="small" fill="clear" color="danger" *ngIf="t.statusz !== 'uj'"
                          [disabled]="kontirVisszavonFut === t.id"
                          title="Kontír visszavonása (a párosítás is)" (click)="kontirVisszavon(t)">
                <ion-spinner *ngIf="kontirVisszavonFut === t.id" name="dots"></ion-spinner>
                <ion-icon *ngIf="kontirVisszavonFut !== t.id" slot="icon-only" name="arrow-undo-outline"></ion-icon>
              </ion-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
  </ng-container>

  <!-- Kézi kontír (soronkénti felülírás + tanulás) -->
  <ion-modal [isOpen]="!!szerkesztTr" (didDismiss)="szerkesztTr = null">
    <ng-template>
      <ion-header><ion-toolbar style="--background:var(--naplo);--color:#fff">
        <ion-title>Kontírozás</ion-title>
        <ion-buttons slot="end"><ion-button (click)="szerkesztTr = null"><ion-icon slot="icon-only" name="close"></ion-icon></ion-button></ion-buttons>
      </ion-toolbar></ion-header>
      <ion-content class="ion-padding" *ngIf="szerkesztTr">
        <p style="margin:0 0 12px"><b>{{ szerkesztTr.partner_nev || '—' }}</b> · <span [style.color]="(szerkesztTr.osszeg||0)<0 ? '#b91c1c' : '#15803d'">{{ fmt(szerkesztTr.osszeg) }} Ft</span></p>
        <!-- PARTNER FELÜLÍRÁSA: más partnerre könyvelés. Könyvelt tételnél a kettős bizonylat
             partnere is követi; üresen hagyva a banki / számla szerinti partner marad. -->
        <div class="partner-felulir-sor">
          <label for="partnerFelulir">Partner (felülírás) – opcionális</label>
          <input id="partnerFelulir" [(ngModel)]="szerkesztTr.partner_felulir" list="partnerNevekListaSzerk"
                 placeholder="{{ szerkesztTr.partner_nev || 'partner neve' }}" autocomplete="off">
          <datalist id="partnerNevekListaSzerk"><option *ngFor="let n of partnerNevek" [value]="n"></option></datalist>
        </div>
        <!-- KÉZI DEVIZÁSÍTÁS: ha a közleményből nem derül ki a deviza, itt megadható – a tétel
             ezután úgy működik, mintha a közleményben állt volna (párosítás, árfolyam, export). -->
        <div class="partner-felulir-sor">
          <label>Deviza (ha a közleményből nem derül ki) – opcionális</label>
          <div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">
            <input type="number" step="0.01" min="0" [(ngModel)]="szerkesztTr.deviza_osszeg" placeholder="várt deviza összeg" style="max-width:160px">
            <select [(ngModel)]="szerkesztTr.deviza_nem" style="font:inherit;padding:8px;border:1px solid #cbd5e1;border-radius:6px">
              <option *ngFor="let d of DEVIZANEMEK" [value]="d">{{ d }}</option>
            </select>
            <span *ngIf="devizaArfolyam(szerkesztTr) as arf" style="font-size:.85rem">árfolyam: <b>{{ arf }}</b> Ft/{{ szerkesztTr.deviza_nem }}</span>
          </div>
          <span style="font-size:.74rem;color:#64748b">{{ szerkesztTr.deviza_kezi ? 'Kézzel megadott deviza. ' : '' }}Üresen hagyva a közleményből olvasott deviza (ha van) marad.</span>
        </div>
        <ion-item><ion-select label="Típus" labelPlacement="stacked" [(ngModel)]="szerkesztTr.tipus">
          <ion-select-option *ngFor="let x of TIPUSOK" [value]="x.k">{{ x.c }}</ion-select-option>
        </ion-select></ion-item>
        <ion-item>
          <div class="fk-sor">
            <ion-input [label]="egyszeres ? 'Naplófőkönyvi rovat' : 'Ellenszámla (főkönyvi)'" labelPlacement="stacked" [(ngModel)]="szerkesztTr.fokonyvi_szam" [placeholder]="egyszeres ? 'pl. 3' : 'pl. 4541'"></ion-input>
            <button type="button" class="fk-mini" (click)="fkNyit(szerkesztTr, 'fokonyvi_szam')" [title]="egyszeres ? 'Választás a rovatok közül' : 'Választás a számlatükörből'"><ion-icon name="list-outline"></ion-icon></button>
          </div>
        </ion-item>
        <ion-note *ngIf="szerkesztTr.fokonyvi_szam && fkNev(szerkesztTr.fokonyvi_szam)" color="medium" style="font-size:.78rem;padding:0 16px">{{ fkNev(szerkesztTr.fokonyvi_szam) }}</ion-note>
        <!-- RLB segéd: a párosított, máshol még le nem könyvelt SZÁMLA saját kontírja. Ha kitöltöd,
             a könyvelés a számla bizonylatát is elkészíti (költség/bevétel + ÁFA + partner).
             Egyszeresnél nincs ilyen: a még le nem könyvelt számla a kifizetett részével magától bekerül. -->
        <ng-container *ngIf="!egyszeres">
        <ion-item>
          <div class="fk-sor">
            <ion-input label="Számla főkönyvi száma (költség/bevétel) – opcionális" labelPlacement="stacked" [(ngModel)]="szerkesztTr.szamla_fokonyvi_szam" placeholder="pl. 5291"></ion-input>
            <button type="button" class="fk-mini" (click)="fkNyit(szerkesztTr, 'szamla_fokonyvi_szam')" title="Választás a számlatükörből"><ion-icon name="list-outline"></ion-icon></button>
          </div>
        </ion-item>
        <ion-note color="medium" style="font-size:.78rem;padding:0 16px">
          <span *ngIf="szerkesztTr.szamla_fokonyvi_szam">{{ fkNev(szerkesztTr.szamla_fokonyvi_szam) }} – a könyvelés a <b>számla bizonylatát is</b> elkészíti a kiegyenlítés mellé.</span>
          <span *ngIf="!szerkesztTr.szamla_fokonyvi_szam">Üresen hagyva csak a kiegyenlítés könyvelődik (a számla máshol van lekönyvelve).</span>
        </ion-note>
        <!-- Fordított adózású számla: az önadózott ÁFA ÖNÁLLÓ vegyes bizonylatra kerül (RLB: XF/XT) -->
        <ion-item lines="none"><ion-checkbox slot="start" [(ngModel)]="szerkesztTr.forditott_afa"></ion-checkbox>
          <ion-label class="ion-text-wrap" style="font-size:.85rem">Fordított adózású számla (az ÁFA külön vegyes bizonylatra kerül)</ion-label></ion-item>
        <ion-item *ngIf="szerkesztTr.forditott_afa"><ion-input type="number" label="Fordított ÁFA kulcs (%)" labelPlacement="stacked" [(ngModel)]="szerkesztTr.forditott_afa_kulcs" placeholder="27"></ion-input></ion-item>
        </ng-container>
        <ion-item lines="none"><ion-checkbox slot="start" [(ngModel)]="szerkesztTr.tanul"></ion-checkbox>
          <ion-label class="ion-text-wrap" style="font-size:.85rem">Tanuld meg erre a partnerre (a jövőben automatikusan így kontírozza)</ion-label></ion-item>
        <ion-button expand="block" style="--background:var(--naplo);margin-top:14px" (click)="trMent()"><ion-icon slot="start" name="save"></ion-icon>Mentés</ion-button>
      </ion-content>
    </ng-template>
  </ion-modal>

  <!-- Bontásos kipontozó: egy tranzakció több számlára osztva -->
  <ion-modal class="kontir-szeles-modal" [isOpen]="!!bontasTr" (didDismiss)="bontasTr = null; bontasSorok = []">
    <ng-template>
      <ion-header><ion-toolbar style="--background:var(--naplo);--color:#fff">
        <ion-title>Bontás több számlára</ion-title>
        <ion-buttons slot="end"><ion-button (click)="bontasTr = null; bontasSorok = []"><ion-icon slot="icon-only" name="close"></ion-icon></ion-button></ion-buttons>
      </ion-toolbar></ion-header>
      <ion-content>
        <div class="naplo-eszkozsor" style="position:sticky;top:0;background:#fff;z-index:3;border-bottom:1px solid #e2e8f0" *ngIf="bontasTr">
          <span><b>{{ bontasTr.partner_nev || '—' }}</b> · <span [style.color]="(bontasTr.osszeg||0)<0 ? '#b91c1c' : '#15803d'">{{ fmt(bontasTr.osszeg) }} Ft</span>
            <span *ngIf="bontasVanDeviza()" class="halvany"> ({{ fmt(abs(bontasTr.deviza_osszeg)) }} {{ bontasTr.deviza_nem }})</span>
          </span>
          <div class="spacer" style="flex:1"></div>
          <!-- A bontás VÉGIG FORINTBAN megy (a bankban forint mozgott). A devizás
               számlákra a „Kész" a banktétel tényleges árfolyamával vált vissza. -->
          <span style="font-size:.85rem">Kiosztva: <b>{{ fmt(bontasOsszeg()) }}</b> · Maradék:
            <b [style.color]="bontasTullepes() ? '#b91c1c' : (bontasMarad() < -0.5 ? '#b45309' : '#334155')">{{ fmt(bontasMarad()) }}</b> Ft
            <!-- Devizás számlánál a negatív maradék NEM hiba: ez lesz az árfolyamkülönbözet. -->
            <span *ngIf="bontasMarad() < -0.5 && bontasVanDevizasKijelolt()" style="color:#b45309">
              · árfolyam-eltérés, a különbözet 9762/8762-re könyvelődik
            </span>
          </span>
          <ion-button size="small" fill="outline" (click)="bontasAuto()" title="Mohó kitöltés a hátralékokból">Auto-kitölt</ion-button>
          <ion-button size="small" style="--background:var(--naplo)" (click)="bontasKesz()"
                      [disabled]="bontasTullepes()"
                      [title]="bontasTullepes() ? 'A kiosztott forint több, mint a tranzakció összege' : 'Párosítás mentése'"><ion-icon slot="start" name="checkmark-outline"></ion-icon>Kész</ion-button>
        </div>
        <div *ngIf="bontasFut" class="ures">Nyitott számlák betöltése…</div>
        <div class="tabla-wrap" style="max-height:calc(93vh - 120px);margin:0" *ngIf="!bontasFut">
          <table class="naplo-tabla">
            <thead><tr><th style="width:34px"></th><th>Bizonylat</th><th>Partner</th><th>Kelt</th><th class="num">Hátralék</th><th class="num">Ebből most</th><th>Jel</th></tr></thead>
            <tbody>
              <tr *ngFor="let r of bontasSorok" [style.opacity]="r.include ? 1 : .5">
                <td><input type="checkbox" [(ngModel)]="r.include"></td>
                <td><b>{{ r.szamla.bizonylatszam || '?' }}</b>
                  <ion-badge *ngIf="bontasSorDevizas(r.szamla)" color="tertiary" style="font-size:.62rem;margin-left:4px">{{ r.szamla.deviza }}</ion-badge>
                </td>
                <td>{{ r.szamla.partner_nev || '—' }}</td>
                <td class="halvany" style="white-space:nowrap">{{ r.szamla.kelt | date:'yyyy.MM.dd' }}</td>
                <!-- Hátralék FORINTBAN; devizás számlánál alatta az EREDETI deviza-összeg
                     (akkor is, ha a banktétel forintos – ilyenkor MNB-vel váltunk). -->
                <td class="num">{{ fmt(bontasHatralekHuf(r.szamla)) }} Ft
                  <div *ngIf="bontasSorDevizas(r.szamla)" class="deviza-jel"
                       [title]="'Alkalmazott árfolyam: ' + fmt(bontasSorArfolyam(r.szamla)) + ' Ft/' + r.szamla.deviza + (bontasDevizasSor(r.szamla) ? ' (banki)' : ' (MNB, ' + r.szamla.mnb_datum + ')')">
                    {{ fmt(r.szamla.hatralek) }} {{ r.szamla.deviza }}
                  </div>
                </td>
                <td class="num"><input type="number" [(ngModel)]="r.osszeg" [disabled]="!r.include" class="j-mezo j-szam" style="text-align:right">
                  <div class="halvany" style="font-size:.72rem">Ft<span *ngIf="bontasSorDevizas(r.szamla) && r.include && bontasSorArfolyam(r.szamla)"> · <b>{{ fmt(bontasHufDevizaraNezet(r.szamla, r.osszeg)) }} {{ r.szamla.deviza }}</b></span></div>
                </td>
                <td><ion-badge *ngFor="let o of r.okok" color="medium" style="font-size:.66rem;margin-right:2px">{{ o }}</ion-badge></td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="!bontasSorok.length" class="ures"><ion-icon name="document-outline"></ion-icon>Nincs nyitott számla ebben az irányban.</div>
        </div>
      </ion-content>
    </ng-template>
  </ion-modal>

  <!-- Kontír-szabályok kezelése -->
  <ion-modal class="kontir-szeles-modal" [isOpen]="szabalyModal" (didDismiss)="szabalyModal = false; ujSzabaly = null">
    <ng-template>
      <ion-header><ion-toolbar style="--background:var(--naplo);--color:#fff">
        <ion-title>Kontír-szabályok</ion-title>
        <ion-buttons slot="end"><ion-button (click)="szabalyModal = false; ujSzabaly = null"><ion-icon slot="icon-only" name="close"></ion-icon></ion-button></ion-buttons>
      </ion-toolbar></ion-header>
      <ion-content class="ion-padding">
        <ion-button size="small" style="--background:var(--naplo)" (click)="szabalyUj()"><ion-icon slot="start" name="add"></ion-icon>Új szabály</ion-button>

        <!-- szabály szerkesztő -->
        <ion-card *ngIf="ujSzabaly" class="naplo-card">
          <ion-card-content>
            <ion-item><ion-input label="Név" labelPlacement="stacked" [(ngModel)]="ujSzabaly.nev"></ion-input></ion-item>
            <ion-grid><ion-row>
              <ion-col size="6"><ion-item><ion-select label="Mező" labelPlacement="stacked" [(ngModel)]="ujSzabaly.mezo">
                <ion-select-option value="partner_nev">Partner név</ion-select-option><ion-select-option value="partner_szamla">Partner számlaszám</ion-select-option>
                <ion-select-option value="kozlemeny">Közlemény</ion-select-option><ion-select-option value="barmi">Bármelyik</ion-select-option>
              </ion-select></ion-item></ion-col>
              <ion-col size="6"><ion-item><ion-select label="Operátor" labelPlacement="stacked" [(ngModel)]="ujSzabaly.operator">
                <ion-select-option value="tartalmaz">tartalmaz</ion-select-option><ion-select-option value="kezdodik">kezdődik</ion-select-option>
                <ion-select-option value="egyenlo">egyenlő</ion-select-option><ion-select-option value="regex">regex</ion-select-option>
                <ion-select-option value="sajat_szamla">saját számla (átvezetés)</ion-select-option>
              </ion-select></ion-item></ion-col>
            </ion-row></ion-grid>
            <ion-item *ngIf="ujSzabaly.operator !== 'sajat_szamla'"><ion-input label="Minta" labelPlacement="stacked" [(ngModel)]="ujSzabaly.minta" placeholder="pl. 10032000 vagy MVM"></ion-input></ion-item>
            <ion-note *ngIf="ujSzabaly.operator === 'sajat_szamla'" style="display:block;padding:4px 16px;font-size:.8rem">Akkor illeszkedik, ha az ellenoldali számlaszám a saját másik bankszámláddal egyezik (átvezetés). Nem kell minta.</ion-note>
            <ion-grid><ion-row>
              <ion-col size="4"><ion-item><ion-select label="Irány" labelPlacement="stacked" [(ngModel)]="ujSzabaly.irany">
                <ion-select-option value="barmi">bármi</ion-select-option><ion-select-option value="be">bevétel (+)</ion-select-option><ion-select-option value="ki">kiadás (−)</ion-select-option>
              </ion-select></ion-item></ion-col>
              <ion-col size="4"><ion-item><ion-select label="Típus" labelPlacement="stacked" [(ngModel)]="ujSzabaly.tipus">
                <ion-select-option *ngFor="let x of TIPUSOK" [value]="x.k">{{ x.c }}</ion-select-option>
              </ion-select></ion-item></ion-col>
              <ion-col size="4"><ion-item><ion-input label="Ellenszámla" labelPlacement="stacked" [(ngModel)]="ujSzabaly.ellenszamla" placeholder="4541"></ion-input></ion-item></ion-col>
            </ion-row></ion-grid>
            <ion-item lines="none"><ion-input label="Prioritás (kisebb = előbb)" labelPlacement="stacked" type="number" [(ngModel)]="ujSzabaly.prioritas"></ion-input></ion-item>
            <ion-item lines="none"><ion-checkbox slot="start" [(ngModel)]="ujSzabaly.aktiv"></ion-checkbox><ion-label style="font-size:.85rem">Aktív (kapcsold ki a szabály letiltásához)</ion-label></ion-item>
            <ion-item lines="none"><ion-checkbox slot="start" [(ngModel)]="ujSzabaly.intezmenyi"></ion-checkbox><ion-label style="font-size:.85rem">Az egész intézményre (ne csak erre az ügyfélre)</ion-label></ion-item>
            <ion-button size="small" style="--background:var(--naplo)" (click)="szabalyMent()"><ion-icon slot="start" name="save"></ion-icon>Mentés</ion-button>
            <ion-button size="small" fill="clear" color="medium" (click)="ujSzabaly = null">Mégse</ion-button>
          </ion-card-content>
        </ion-card>

        <!-- szabály-lista -->
        <div class="tabla-wrap" style="margin:12px 0">
          <table class="naplo-tabla">
            <thead><tr><th>Prio</th><th>Név</th><th>Feltétel</th><th>Irány</th><th>Típus</th><th>Ellenszámla</th><th>Hatókör</th><th class="jobb"></th></tr></thead>
            <tbody>
              <tr *ngFor="let s of szabalyok" [style.opacity]="s.aktiv ? 1 : .5">
                <td>{{ s.prioritas }}</td>
                <td>{{ s.nev }} <ion-badge *ngIf="s.beepitett" color="medium">gyári</ion-badge></td>
                <td class="halvany">{{ s.mezo }} {{ s.operator }} „{{ s.minta }}"</td>
                <td>{{ s.irany }}</td>
                <td>{{ tipusCimke(s.tipus) }}</td>
                <td><b>{{ s.ellenszamla || '—' }}</b></td>
                <td class="halvany">{{ s.ugyfel_id ? 'ügyfél' : 'intézmény' }}</td>
                <td class="jobb" style="white-space:nowrap">
                  <ion-button size="small" fill="clear" (click)="szabalySzerkeszt(s)"><ion-icon slot="icon-only" name="create-outline"></ion-icon></ion-button>
                  <ion-button size="small" fill="clear" color="danger" (click)="szabalyTorol(s)"><ion-icon slot="icon-only" name="trash-outline"></ion-icon></ion-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ion-content>
    </ng-template>
  </ion-modal>
</ng-container>

<!-- RLB export – időszak megadása -->
<ion-modal [isOpen]="rlbModal" (didDismiss)="rlbModal = false" class="rlb-export-modal">
  <ng-template>
    <ion-header><ion-toolbar style="--background:var(--naplo);--color:#fff">
      <ion-title>RLB export</ion-title>
      <ion-buttons slot="end"><ion-button (click)="rlbModal = false"><ion-icon slot="icon-only" name="close"></ion-icon></ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <div class="rlb-body">
      <!-- Két külön út az RLB-be: kész feladás vagy nyers kivonat. A devizás számla
           kiegyenlítését csak a második (az RLB saját bankfeldolgozója) tudja. -->
      <ion-segment [ngModel]="rlbUt" (ngModelChange)="rlbUtValt($event)" style="margin-bottom:12px">
        <ion-segment-button value="feladas"><ion-label>Feladás</ion-label></ion-segment-button>
        <ion-segment-button value="kivonat"><ion-label>Bankkivonat</ion-label></ion-segment-button>
      </ion-segment>

      <p *ngIf="rlbUt === 'feladas'" style="margin:0 0 14px;font-size:.86rem;color:#64748b">
        Kész könyvelés az RLB <b>Könyvelés → Automatikus könyvelés csv-ből</b> menüpontjához: a kontírozott/könyvelt
        banki tételek többsoros formátumban{{ szuro.bank_id ? ' (a kiválasztott bankszámláról)' : ' (minden bankszámláról)' }}.
        Ez a menüpont a devizás számlák kiegyenlítését nem kezeli – lásd alább.
      </p>
      <!-- Az átvezetős megoldás a FELADÁS úthoz készült: ott a devizás tételek kimaradnak a
           CSV-ből, és az átvezető kivonat viszi őket. A forintos kivonat ellenben MINDEN tételt
           tartalmaz (az a bankszámla valós forgalma), ezért a kettő nem kombinálható. -->

      <!-- A kivonat-formátumban nincs főkönyvi oszlop: amit az RLB nem tud számlához párosítani,
           annál üresen marad a „Nettó fsz." – arra valók a párosítási feltételek. -->
      <div class="rlb-feltetelek" *ngIf="rlbUt === 'kivonat' && feltetelekFontos.length">
        <h5><ion-icon name="construct-outline"></ion-icon> Párosítási feltételek, amiket érdemes felvinni ({{ feltetelekFontos.length }})</h5>
        <p>
          A kivonatban nincs főkönyvi oszlop – amit az RLB nem párosít számlához, annál üres marad a
          <b>Nettó fsz.</b> Ezeket egyszer kell felvinni az RLB <b>Új feltétel</b> gombjával, utána minden hónapban
          maguktól kitöltődnek. A mi kontírunkból:
        </p>
        <div class="rlb-devizas-tabla">
          <table>
            <thead><tr><th>Típus</th><th>Partner</th><th class="jobb">Nettó fsz.</th><th class="jobb">Db</th></tr></thead>
            <tbody>
              <tr *ngFor="let f of feltetelekFontos">
                <td>{{ f.tipus }}</td><td>{{ f.partner_nev }}</td>
                <td class="jobb"><b>{{ f.fokonyvi_szam }}</b></td><td class="jobb">{{ f.db }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <ion-button size="small" fill="outline" (click)="feltetelekMasol()">
          <ion-icon slot="start" name="copy-outline"></ion-icon>Mind ({{ feltetelek.length }}) vágólapra
        </ion-button>
      </div>

      <p *ngIf="rlbUt === 'kivonat'" style="margin:0 0 14px;font-size:.86rem;color:#64748b">
        Bankszámlatörténet az RLB <b>Könyvelés → Automatikus bank könyvelés → Bank könyvelése (RLB)</b> feldolgozójához,
        <b>RLB(CSV)</b> banktípussal. A párosítást és a könyvelést az RLB végzi – így a <b>devizás számla kiegyenlítése is
        automatikus</b>. Számlához párosított tételnél a partnernév a <b>számla partnerének RLB-beli neve</b> (adószám, majd név
        alapján) – így a SimplePay-, kártyás és csomagautomatás fizetés is a valódi partnerre párosul –, egyébként az alias-tábla
        szerinti név megy ki; a már ismert számlaszám a közlemény elejére kerül,
        hogy az RLB automatikusan megtalálja a kiegyenlítendő tételt. Egy fájl egy bankszámláé, és a bankszámlaszámnak
        egyeznie kell az RLB főkönyvi törzsében megadottal.
      </p>
      <div class="rlb-oszlopok">
      <div class="rlb-beallitas">
      <div style="display:flex;gap:10px;flex-wrap:wrap">
        <!-- ngModelChange (nem ionChange): az utóbbi csak fókuszvesztéskor sül el, így a panel a
             RÉGI tartományon maradhatott, miközben az export már az újjal futott. -->
        <ion-item style="flex:1;min-width:150px"><ion-input type="date" label="Ettől" labelPlacement="stacked"
          [ngModel]="rlbTartomany.tol" (ngModelChange)="rlbTartomany.tol = $event; tartomanyValt()"></ion-input></ion-item>
        <ion-item style="flex:1;min-width:150px"><ion-input type="date" label="Eddig" labelPlacement="stacked"
          [ngModel]="rlbTartomany.ig" (ngModelChange)="rlbTartomany.ig = $event; tartomanyValt()"></ion-input></ion-item>
      </div>

      <!-- Export ELŐTTI figyelmeztetés: a feladás-út a devizás kiegyenlítést nem viszi át. -->
      <div class="rlb-figyelmeztet" *ngIf="rlbDevizasok.length && rlbDevizasMod !== 'kihagy'">
        <ion-icon name="information-circle-outline"></ion-icon>
        <div>
          Ebben az időszakban <b>{{ rlbDevizasok.length }} devizás kiegyenlítés</b> van (pl.
          {{ rlbDevizasok[0].partner_nev }}). A feladás-úton az RLB ezeket nem tudja lekönyvelni,
          ezért a beállítás szerint kimaradnak vagy forintosítva mennek.
          <a href="javascript:void(0)" (click)="rlbUt = 'kivonat'">Váltás a Bankkivonatra</a>, ahol az RLB
          maga rendezi őket.
        </div>
      </div>
      <!-- Devizás számla kiegyenlítése: az importja a devizás SZÁMLÁT fogadja, a
           KIEGYENLÍTÉSÉT nem („A devizás kiegyenlítést nem kezeli a program.").
           A kivonat-úton ez nem kérdés, ott az RLB maga kezeli. -->
      <!-- Devizás kiegyenlítés: a banki soron ez FORINTKÉNT látszik (a bank váltott), hogy
           devizás-e, azt a párosítás mondja meg. Mindkét úton eldönthető, mi legyen velük. -->
      <ion-item lines="none" style="margin-top:10px;--padding-start:0">
        <ion-select label="Devizás kiegyenlítés" labelPlacement="stacked" interface="popover"
          [(ngModel)]="rlbDevizasMod">
          <ion-select-option value="kihagy">Kihagyás – az EUR átvezetőre megy (ajánlott)</ion-select-option>
          <ion-select-option value="forint" *ngIf="rlbUt === 'feladas'">Forintosítva, árfolyam-bizonylattal</ion-select-option>
          <ion-select-option value="marad" *ngIf="rlbUt === 'kivonat'">Benne marad, forintként</ion-select-option>
        </ion-select>
      </ion-item>
      <p style="margin:2px 0 0;font-size:.76rem;color:#64748b">
        <ng-container *ngIf="rlbDevizasMod === 'kihagy'">
          Nem kerülnek ebbe a fájlba – az <b>EUR átvezető kivonat</b> viszi őket (az tartalmazza a forintszámla
          jóváírását is, tehát semmi nem duplázódik). Ha nem az átvezetőt használod, az RLB
          <b>Devizás számlák kiegyenlítése</b> képernyőjén rögzítheted őket kézzel, az alábbi adatokkal.
        </ng-container>
        <ng-container *ngIf="rlbDevizasMod === 'forint'">
          Forintosítva, kiegyenlítés-hivatkozás nélkül kerülnek a CSV-be, mellettük önálló árfolyam-bizonylattal.
          A főkönyv és a bankegyenleg így teljes az importból, de a számla a pénzügyi nyilvántartásban nyitva marad.
        </ng-container>
        <ng-container *ngIf="rlbDevizasMod === 'marad'">
          Forintként benne maradnak a kivonatban (ez a bankszámla valós forgalma). Az RLB nem tudja párosítani őket
          devizás számlához – ilyenkor NE töltsd be mellé az átvezető kivonatot, mert kétszer könyvelnéd.
        </ng-container>
      </p>

      <ion-button expand="block" style="--background:var(--naplo);margin-top:14px" (click)="rlbExport()" [disabled]="rlbFut">
        <ion-spinner *ngIf="rlbFut" name="dots"></ion-spinner>
        <span *ngIf="!rlbFut">
          <ion-icon slot="start" name="download-outline"></ion-icon>
          {{ rlbUt === 'kivonat' ? 'Bankkivonat letöltése' : 'Export letöltése' }}
        </span>
      </ion-button>
      </div><!-- /rlb-beallitas -->

      <!-- Devizás kiegyenlítések: az RLB importja ezeket nem tudja lekönyvelni, ezért
           nincsenek a CSV-ben. Itt van minden szám, amit a kézi rögzítés kér. -->
      <!-- A devizás panel MÁR AZ EXPORT ELŐTT látszik: az EUR átvezető kivonat letöltése
           ne legyen elrejtve a feladás-export mögé. -->
      <div class="rlb-devizas" *ngIf="rlbDevizasok.length">
        <h4>
          <ion-icon name="alert-circle-outline"></ion-icon>
          Devizás kiegyenlítés – {{ rlbTartomany.tol }} … {{ rlbTartomany.ig }} ({{ rlbDevizasok.length }} db)
        </h4>
        <p *ngIf="rlbDevizasMod === 'kihagy'">
          Az RLB importja a devizás számlák kiegyenlítését nem kezeli („A devizás kiegyenlítést nem kezeli
          a program."), ezért ezek a banki tételek <b>{{ rlbExportalt ? 'kimaradtak' : 'kimaradnak' }}</b> a feladás-CSV-ből –
          így a többi tétel gond nélkül feladható. Két megoldás: vagy az alábbi <b>EUR átvezető kivonattal</b>
          (automatikus), vagy kézzel az RLB <b>Devizás számlák kiegyenlítése</b> képernyőjén – ott forintos bank
          választásakor a <b>deviza</b> és a <b>forint</b> összeget kéri, az árfolyamot és a különbözetet maga számolja
          (az alábbi értékeket kell kapnod).
        </p>
        <p *ngIf="rlbDevizasMod === 'forint'">
          Ezek a tételek <b>forintosítva</b> bekerültek a CSV-be (partnerszámla / bank), mellettük önálló
          árfolyam-bizonylattal – a főkönyv és a bankegyenleg tehát rendben lesz az importból. Kiegyenlítés-
          hivatkozás viszont nem mehetett velük, ezért a számlák a pénzügyi nyilvántartásban nyitva maradnak:
          ott jelöld le őket az alábbi adatokkal.
        </p>
        <div class="rlb-devizas-tabla">
          <table>
            <thead>
              <tr>
                <th>Dátum</th><th>Partner</th><th>Számla</th>
                <th class="jobb">Deviza</th><th class="jobb">Forint</th>
                <th class="jobb">Árfolyam</th><th class="jobb">Könyv szerinti</th>
                <th class="jobb">Árf. különbözet</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let t of rlbDevizasok">
                <tr *ngFor="let x of t.tetelek">
                  <td>{{ t.datum }}</td>
                  <td>{{ x.partner_nev }}</td>
                  <td>{{ x.bizonylatszam }}</td>
                  <td class="jobb">{{ x.deviza_osszeg }} {{ x.deviza }}</td>
                  <td class="jobb">{{ x.forint | number:'1.0-0' }} Ft</td>
                  <td class="jobb">{{ x.arfolyam }}</td>
                  <td class="jobb">{{ x.konyv_szerinti_forint | number:'1.0-2' }} Ft</td>
                  <td class="jobb" [class.veszteseg]="x.arfolyam_kulonbozet < 0">
                    {{ x.arfolyam_kulonbozet | number:'1.0-2' }} Ft
                    <small *ngIf="x.eredmeny_szamla">({{ x.eredmeny_szamla }})</small>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
        <ion-button size="small" fill="outline" (click)="rlbDevizasMasol()">
          <ion-icon slot="start" name="copy-outline"></ion-icon>Másolás vágólapra
        </ion-button>

        <!-- Az átvezető „bankos" automata kiegyenlítést KIVEZETTÜK: az RLB a technikai
             deviza-számlát átlagárfolyamon vezeti ki, ezért vagy a forint egyenleg nem
             nullázódik, vagy kettős árfolyam-különbözet keletkezik. A devizás tételek
             forintosítva mennek át (deviza + árfolyam a soron), a számlák párosítását
             pedig a könyvelő végzi az RLB pénzügyi nyilvántartásában. -->

      </div>
      </div><!-- /rlb-oszlopok -->
    </div>
  </ng-template>
</ion-modal>

<!-- Főkönyvi-szám választó (számlatükörből) -->
<ion-modal [isOpen]="fkPicker.open" (didDismiss)="fkPicker.open = false">
  <ng-template>
    <ion-header><ion-toolbar style="--background:var(--naplo);--color:#fff">
      <ion-title>{{ egyszeres ? 'Naplófőkönyvi rovat választása' : 'Főkönyvi szám választása' }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="fkPicker.open = false"><ion-icon slot="icon-only" name="close"></ion-icon></ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content>
      <ion-searchbar [(ngModel)]="fkPicker.kereses" placeholder="Keresés szám vagy név szerint…" [debounce]="120"></ion-searchbar>
      <ion-list>
        <ion-item button *ngFor="let s of fkSzurt(); trackBy: fkTrack" (click)="fkValaszt(s)" detail="false">
          <ion-label><b>{{ s.szamlaszam }}</b> &nbsp; {{ s.nev }}</ion-label>
        </ion-item>
        <ion-item *ngIf="!fkSzurt().length" lines="none"><ion-label color="medium">Nincs találat.</ion-label></ion-item>
      </ion-list>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- RLB partner-nevek (banki név → RLB-név az exporthoz) -->
<ion-modal [isOpen]="aliasModal" (didDismiss)="aliasModal = false">
  <ng-template>
    <ion-header><ion-toolbar style="--background:var(--naplo);--color:#fff">
      <ion-title>RLB partner-nevek</ion-title>
      <ion-buttons slot="end"><ion-button (click)="aliasModal = false"><ion-icon slot="icon-only" name="close"></ion-icon></ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding">
      <p style="font-size:.85rem;color:#64748b;margin:0 0 12px">
        Ha egy banki partnernév eltér az RLB-ben tárolttól, itt megadhatod, milyen néven kerüljön az export fájlba.
        A párosítás <b>pontos</b> (a banki névvel egyezik). Számlához párosított tételnél nem kell alias: az export a
        számla partnerének RLB-nevét írja ki (az RLB-partnertörzsből, adószám alapján).
      </p>
      <div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:14px">
        <!-- Nincs accept-szűrés: az RLB partnertörzs jöhet XLS/XLSX-ben, CSV-ben és DBF-ben is
             (a program DBF-alapú), a szűrő pedig épp a valódi fájlt tiltotta ki a választóból. -->
        <input type="file" (change)="rlbPartnerImport($event)" hidden #rlbFile>
        <ion-button size="small" fill="outline" (click)="rlbFile.click()" [disabled]="rlbImportFut" title="Az RLB partnertörzs (XLS) beolvasása – ez adja a választható RLB-neveket és az összevezetés alapját">
          <ion-spinner *ngIf="rlbImportFut" name="dots"></ion-spinner>
          <span *ngIf="!rlbImportFut"><ion-icon slot="start" name="cloud-upload-outline"></ion-icon>RLB partnertörzs importálása</span>
        </ion-button>
        <ion-button size="small" style="--background:var(--naplo)" (click)="rlbOsszevezet()" [disabled]="rlbOsszFut" title="A banki partnereket bankszámlaszám/név alapján az RLB partnerekhez köti, és ahol a név eltér, aliast hoz létre">
          <ion-spinner *ngIf="rlbOsszFut" name="dots"></ion-spinner>
          <span *ngIf="!rlbOsszFut"><ion-icon slot="start" name="git-compare-outline"></ion-icon>Automatikus összevezetés</span>
        </ion-button>
      </div>
      <ion-row class="ion-align-items-end">
        <ion-col size="12" sizeMd="5">
          <label class="alias-cimke">Banki név (a banki tételekből)</label>
          <input class="alias-input" [(ngModel)]="ujAlias.minta" list="bankiNevekLista" placeholder="válaszd ki vagy gépeld" autocomplete="off">
          <datalist id="bankiNevekLista"><option *ngFor="let n of bankiNevekSzabad" [value]="n"></option></datalist>
        </ion-col>
        <ion-col size="12" sizeMd="5">
          <label class="alias-cimke">RLB-név (a saját partnerlistádból)</label>
          <input class="alias-input" [(ngModel)]="ujAlias.rlb_nev" list="torzsNevekLista" placeholder="válaszd ki vagy gépeld" autocomplete="off">
          <datalist id="torzsNevekLista"><option *ngFor="let n of torzsNevek" [value]="n"></option></datalist>
        </ion-col>
        <ion-col size="12" sizeMd="2"><ion-button expand="block" style="--background:var(--naplo)" (click)="aliasHozzaad()"><ion-icon slot="start" name="add"></ion-icon>Hozzáad</ion-button></ion-col>
      </ion-row>
      <ion-list>
        <ion-item *ngFor="let a of aliasok">
          <ion-label class="ion-text-wrap"><b>{{ a.minta }}</b> &nbsp;→&nbsp; {{ a.rlb_nev }}</ion-label>
          <ion-button slot="end" fill="clear" color="danger" (click)="aliasTorol(a)"><ion-icon slot="icon-only" name="trash-outline"></ion-icon></ion-button>
        </ion-item>
        <ion-item *ngIf="!aliasok.length" lines="none"><ion-label color="medium">Még nincs partner-alias.</ion-label></ion-item>
      </ion-list>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- ════════ VEVŐ/SZÁLLÍTÓ SZÁMLÁK KIEGYENLÍTÉSE ════════ -->
<ion-modal class="kontir-szeles-modal" [isOpen]="vszModal" (didDismiss)="vszModal = false">
  <ng-template>
    <ion-header><ion-toolbar style="--background:var(--naplo); --color:#fff">
      <ion-title>Vevő/Szállító számlák kiegyenlítése</ion-title>
      <ion-buttons slot="end"><ion-button (click)="vszModal = false"><ion-icon slot="icon-only" name="close"></ion-icon></ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content>
      <div class="naplo-eszkozsor vsz-szuro" style="position:sticky;top:0;background:#fff;z-index:3;border-bottom:1px solid #e2e8f0">
        <ion-input [(ngModel)]="vszSzuro.kereses" label="Szűkítés" labelPlacement="stacked"
                   placeholder="bizonylatszám, partner, közlemény" style="max-width:260px"></ion-input>
        <ion-select [(ngModel)]="vszSzuro.mod" interface="popover" label="Mód" style="max-width:150px">
          <ion-select-option value="eleje">Eleje egyezik</ion-select-option>
          <ion-select-option value="tartalmaz">Tartalmazza</ion-select-option>
        </ion-select>
        <ion-select [(ngModel)]="vszSzuro.deviza" interface="popover" label="Deviza" style="max-width:150px">
          <ion-select-option value="">Minden tétel</ion-select-option>
          <ion-select-option value="HUF">HUF</ion-select-option>
          <ion-select-option value="EUR">EUR</ion-select-option>
          <ion-select-option value="USD">USD</ion-select-option>
        </ion-select>
        <ion-item lines="none"><ion-checkbox slot="start" [(ngModel)]="vszSzuro.vevo"></ion-checkbox><ion-label>Vevő számlák</ion-label></ion-item>
        <ion-item lines="none"><ion-checkbox slot="start" [(ngModel)]="vszSzuro.szallito"></ion-checkbox><ion-label>Szállító számlák</ion-label></ion-item>
        <ion-item lines="none"><ion-checkbox slot="start" [(ngModel)]="vszSzuro.rendezett" (ionChange)="vszBetolt()"></ion-checkbox><ion-label>Rendezett számlákat is mutassa</ion-label></ion-item>
        <span class="spacer" style="flex:1"></span>
        <ion-button size="small" fill="outline" [disabled]="vszFut" (click)="vszBetolt()">
          <ion-icon slot="start" [name]="vszFut ? 'hourglass-outline' : 'refresh-outline'"></ion-icon>Frissítés</ion-button>
      </div>

      <div class="vsz-racs">
        <!-- bal: számlák -->
        <div class="vsz-oszlop">
          <div class="vsz-cim">
            Nyitott számlák <span class="halvany">({{ vszSzamlaSorok.length }})</span>
            <span class="spacer" style="flex:1"></span>
            <ion-button size="small" fill="clear" (click)="vszMindSzamla(true)">Mind</ion-button>
            <ion-button size="small" fill="clear" (click)="vszMindSzamla(false)">Egyik se</ion-button>
          </div>
          <div class="tabla-wrap">
            <table class="naplo-tabla">
              <thead><tr><th style="width:34px"></th><th>Bizonylatszám</th><th>Partner neve</th><th>Szla.kelte</th><th>Fiz.hat.</th><th class="jobb">Végösszeg</th><th class="jobb">Hátralék</th></tr></thead>
              <tbody>
                <tr *ngFor="let s of vszSzamlaSorok" [class.kijelolt]="vszKijeloltSzamla.has(s.id)"
                    [class.rendezett]="s.hatralek <= 0.5" (click)="vszSzamlaValt(s)">
                  <td><ion-checkbox [checked]="vszKijeloltSzamla.has(s.id)" [disabled]="(s.deviza || 'HUF') !== 'HUF'"></ion-checkbox></td>
                  <td>{{ s.bizonylatszam }}<ion-badge color="medium" *ngIf="s.tipus === 'szallito'" style="margin-left:4px">szá</ion-badge></td>
                  <td>{{ s.partner_nev }}</td>
                  <td>{{ s.kelt | date:'yyyy.MM.dd' }}</td>
                  <td>{{ s.fizetesi_hatarido ? (s.fizetesi_hatarido | date:'yyyy.MM.dd') : '—' }}</td>
                  <td class="jobb">{{ s.brutto | number:'1.0-0' }} {{ s.deviza !== 'HUF' ? s.deviza : '' }}</td>
                  <td class="jobb"><b>{{ s.hatralek | number:'1.0-0' }}</b></td>
                </tr>
              </tbody>
            </table>
            <div class="ures" *ngIf="!vszSzamlaSorok.length"><ion-icon name="documents-outline"></ion-icon>Nincs a szűrésnek megfelelő számla.</div>
          </div>
        </div>

        <!-- jobb: banktételek -->
        <div class="vsz-oszlop">
          <div class="vsz-cim">
            Kipontozatlan banktételek <span class="halvany">({{ vszTetelSorok.length }})</span>
            <span class="spacer" style="flex:1"></span>
            <ion-button size="small" fill="clear" (click)="vszMindTetel(true)">Mind</ion-button>
            <ion-button size="small" fill="clear" (click)="vszMindTetel(false)">Egyik se</ion-button>
          </div>
          <div class="tabla-wrap">
            <table class="naplo-tabla">
              <thead><tr><th style="width:34px"></th><th>Dátum</th><th>Partner</th><th>Közlemény</th><th class="jobb">Összeg</th></tr></thead>
              <tbody>
                <tr *ngFor="let t of vszTetelSorok" [class.kijelolt]="vszKijeloltTetel.has(t.id)" (click)="vszTetelValt(t)">
                  <td><ion-checkbox [checked]="vszKijeloltTetel.has(t.id)" [disabled]="(t.devizanem || 'HUF') !== 'HUF'"></ion-checkbox></td>
                  <td>{{ t.datum | date:'yyyy.MM.dd' }}</td>
                  <td class="n-partner-cella" [title]="t.partner_nev || ''"><div class="n-partner-nev">{{ t.partner_nev || '—' }}</div></td>
                  <td class="halvany">{{ t.kozlemeny || '—' }}</td>
                  <td class="jobb" [class.negativ]="t.osszeg < 0"><b>{{ t.osszeg | number:'1.0-0' }}</b></td>
                </tr>
              </tbody>
            </table>
            <div class="ures" *ngIf="!vszTetelSorok.length"><ion-icon name="card-outline"></ion-icon>Nincs kipontozatlan banktétel.</div>
          </div>
        </div>
      </div>

      <div class="vsz-labjegyzet">
        <span>Kijelölt számla: <b>{{ vszSzamlaOssz | number:'1.0-0' }} Ft</b></span>
        <span>Kijelölt banktétel: <b>{{ vszTetelOssz | number:'1.0-0' }} Ft</b></span>
        <span [class.elter]="vszKulonbozet">Különbözet: <b>{{ vszKulonbozet | number:'1.0-0' }} Ft</b></span>
        <span class="halvany">A kiosztás esedékesség szerint tölti fel a számlákat – egy tétel több számlára, egy számla több tételből is rendezhető.</span>
        <span class="spacer" style="flex:1"></span>
        <ion-button style="--background:var(--naplo)" [disabled]="vszFut || !vszKijeloltTetel.size || !vszKijeloltSzamla.size" (click)="vszKiegyenlit()">
          <ion-icon slot="start" name="checkmark-done-outline"></ion-icon>Kiegyenlítés
        </ion-button>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
